module.exports = __webpack_public_path__ + "static/dots-icon-48513071f5c71357be4d9bfc6a296c28.png";